import ErrorBoundary from '@office-start/error-boundary';
import classnames from 'classnames';
import React from 'react';
import { useLogPageView } from '../../hooks';
import styles from './Page.module.scss';
import { PageError } from './PageError';
var PageErrorBoundary = function (_a) {
    var _b;
    var children = _a.children, errorEventName = _a.errorEventName, name = _a.name;
    return (React.createElement(ErrorBoundary, { fallbackRender: PageError, errorEventName: "ErrorBoundaryPage_".concat((_b = errorEventName !== null && errorEventName !== void 0 ? errorEventName : name) !== null && _b !== void 0 ? _b : 'Unknown') }, children));
};
export var Page = function (_a) {
    var children = _a.children, className = _a.className, errorEventName = _a.errorEventName, name = _a.name, noBuiltInClasses = _a.noBuiltInClasses, style = _a.style;
    useLogPageView({ pageName: name });
    return (React.createElement(PageErrorBoundary, { errorEventName: errorEventName, name: name },
        React.createElement("div", { style: style, className: classnames(noBuiltInClasses ? undefined : styles.page, className), role: "main" }, children)));
};
export var PageUnstyled = function (_a) {
    var children = _a.children, errorEventName = _a.errorEventName, name = _a.name;
    useLogPageView({ pageName: name });
    return (React.createElement(PageErrorBoundary, { errorEventName: errorEventName, name: name }, children));
};
//# sourceMappingURL=Page.js.map